import CreateProfile from './CreateProfile';

export default CreateProfile;
